<template>
  <div class="mt-4" v-if="showComponent">
    <vs-card>
      <div slot="header">
        <h3>Boletim de Ocorrência</h3>
      </div>
      <div>
        <div class="vx-row mt-4">
          <!-- Número Boletim de Ocorrência (para envolvidos) -->
          <div class="vx-col lg:w-1/3 xl:w-1/3 w-full mb-2" v-if="envolvido">
            <vs-input
              class="w-full"
              label="Número do Boletim de Ocorrência"
              name="Número do Boletim de Ocorrência"
              v-model="formBoletimOcorrencia.numeroBO"
            />
          </div>

          <!-- Data Registro BO -->
          <div class="vx-col lg:w-1/3 xl:w-1/3 w-full mb-2">
            <InputDate
              v-model="formBoletimOcorrencia.dataBoletim"
              label="Data Registro BO"
              name="Data Registro BO"
              :config="configdateTimePickerDay"
            />
          </div>

          <!-- Hora Registro BO -->
          <div class="vx-col lg:w-1/3 xl:w-1/3 w-full mb-2">
            <label class="vs-input--label">Hora Registro BO</label>
            <div class="inputData">
              <vs-input
                class="w-full"
                v-model="formBoletimOcorrencia.horaBoletim"
                v-mask="'##:##'"
                :danger="formBoletimOcorrencia.dataBoletim && !formBoletimOcorrencia.horaBoletim"
                maxlength="5"
                placeholder="HH:MM"
                name="Hora Registro BO"
                @input="
                  validaHoraMinuto(
                    formBoletimOcorrencia.horaBoletim,
                    'horaBoletim',
                  )
                "
              />
            </div>
          </div>

          <!-- Dias após o fato (para beneficiários)-->
          <div class="vx-col lg:w-1/3 xl:w-1/3 w-full mb-2" v-if="!envolvido">
            <vs-input
              class="w-full"
              label="Dias após o fato"
              name="Dias após o fato"
              v-model="nrDias"
              disabled="true"
            />
          </div>
        </div>

        <div class="vx-row mt-4">
          <!-- Elaboração do BO Presencial? (para beneficiários)-->
          <div class="vx-col sm:w-1/3 xl:w-2/12 w-full mb-2" v-if="!envolvido">
            <label class="vs-input--label">Elaboração do BO Presencial?</label>
            <vs-switch
              v-model="formBoletimOcorrencia.boletimPresencial"
              color="success"
              class="mt-2 ml-2"
            >
              <span slot="on">sim</span>
              <span slot="off">não</span>
            </vs-switch>
          </div>

          <!-- BO Online? (para beneficiários)-->
          <div class="vx-col sm:w-1/3 xl:w-2/12 w-full mb-2" v-if="!envolvido">
            <label class="vs-input--label">BO Online?</label>
            <vs-switch
              v-model="formBoletimOcorrencia.boletimOnline"
              color="success"
              class="mt-2 ml-2"
            >
              <span slot="on">sim</span>
              <span slot="off">não</span>
            </vs-switch>
          </div>

          <!-- Houve vítima? -->
          <div class="vx-col sm:w-1/3 xl:w-2/12 w-full mb-2">
            <label class="vs-input--label">Houve vítima?</label>
            <vs-switch
              v-model="formBoletimOcorrencia.possuiVitima"
              color="success"
              class="mt-2 ml-2"
            >
              <span slot="on">sim</span>
              <span slot="off">não</span>
            </vs-switch>
          </div>

          <!-- Monta (para beneficiários)-->
          <div class="vx-col xl:w-1/2 w-full mb-2" v-if="!envolvido">
            <label class="vs-select--label">Monta</label>
            <v-select
              :options="listMonta"
              name="Monta"
              id="Monta"
              v-model="formBoletimOcorrencia.idMonta"
              label="label"
              :reduce="(item) => item.id"
            ></v-select>
          </div>
        </div>

        <div class="vx-row mt-4">
          <div class="vx-col w-full">
            <p>Relato do Boletim de Ocorrência</p>
            <vue-editor
              v-model="formBoletimOcorrencia.descricaoBoletim"
              :editor-toolbar="customToolbar"
              class="w-full"
            ></vue-editor>
          </div>
        </div>
      </div>
    </vs-card>
  </div>
</template>

<script>
import vSelect from 'vue-select';
import moment from 'moment';
import { VueEditor } from 'vue2-editor';
import customToolbar from './../../../../../components/editor/config';

import dateConversion from '../../../../../utils/dateConversion';
import functions from '../../../../../utils/functions';
import notify from '../../../../../utils/notify';
import InputDate from '../../../../../components/InputDate.vue';

export default {
  props: ['formData', 'dominios', 'envolvido'],
  watch: {
    formData(value) {
      if (
        value.dadosEventos &&
        value.dadosEventos.dataEvento &&
        value.dadosEventos.horaEvento
      ) {
        this.dataHoraEvento = `${dateConversion.convertDateToISO(
          value.dadosEventos.dataEvento,
        )} ${value.dadosEventos.horaEvento}`;
      }

      if (!value.boletimOcorrencia) {
        this.showComponent = false;
        console.error('ERRO NO CONTRATO DO OBJETO - BOLETIM OCORRENCIA FORM');
        return;
      }

      this.formBoletimOcorrencia = Object.assign(
        this.formBoletimOcorrencia,
        value.boletimOcorrencia,
      );

      if (this.formBoletimOcorrencia.horaBoletim) {
        this.formBoletimOcorrencia.horaBoletim =
          this.formBoletimOcorrencia.horaBoletim
            .split(':')
            .filter((value, index) => index < 2)
            .join(':');
      }
      // eslint-disable-next-line vue/no-mutating-props
      this.formData.boletimOcorrencia = this.formBoletimOcorrencia;
    },
  },
  components: {
    InputDate,
    vSelect,
    VueEditor,
  },
  data() {
    return {
      customToolbar,
      showComponent: true,
      dataHoraEvento: null,
      formBoletimOcorrencia: {
        dataBoletim: null,
        horaBoletim: null,
        boletimPresencial: null,
        boletimOnline: null,
        possuiVitima: null,
        idMonta: null,
        descricaoBoletim: null,
      },

      listMonta: [],

      // Configurações de Component
      configdateTimePickerHour: {
        enableTime: true,
        noCalendar: true,
        dateFormat: 'H:i',
        time_24hr: true,
      },
    };
  },
  computed: {
    nrDias() {
      if (
        !this.dataHoraEvento ||
        !this.formBoletimOcorrencia.dataBoletim ||
        !this.formBoletimOcorrencia.horaBoletim
      ) {
        return '';
      }

      const auxDataHoraBoletim = `${dateConversion.convertDateToISO(
        this.formBoletimOcorrencia.dataBoletim,
      )} ${this.formBoletimOcorrencia.horaBoletim}`;

      const ms = moment(auxDataHoraBoletim).diff(this.dataHoraEvento);

      return functions.formataMsParaData(ms);
    },
  },
  methods: {
    validaHoraMinuto(newValue, campo) {
      if (newValue.length >= 5) {
        if (!/^(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]$/.test(newValue)) {
          notify.notifyFail(
            this.$vs,
            `Hora ${campo} inválida. Insira uma hora válida no formato HH:MM`,
          );
          this.formBoletimOcorrencia[campo] = '';
        }
      }
    },
  },
  mounted() {
    if (!this.formData.boletimOcorrencia) {
      console.error('ERRO NO CONTRATO DO OBJETO - BOLETIM OCORRENCIA FORM');
      this.showComponent = false;
    }

    // eslint-disable-next-line vue/no-mutating-props
    this.formData.boletimOcorrencia = this.formBoletimOcorrencia;

    if (this.dominios) {
      this.listMonta = this.dominios.listMonta;
    }
  },
};
</script>

<style>
.vdp-datepicker input {
  width: 100%;
}

input.flatpickr-input {
  width: 100%;
}
</style>
